import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { PerioTooth, PerioProbingDepthsBySegment } from '../models/perio.models';

@Component({
  standalone: false,
  selector: 'app-probing-summary',
  templateUrl: './probing-summary.component.html',
  styleUrls: ['./probing-summary.component.css']
})
export class ProbingDepthSegmentsSummaryComponent implements OnInit {

  chartTeeth: PerioTooth[];
  probingSegmentData: PerioProbingDepthsBySegment = new PerioProbingDepthsBySegment();
  segments: number[] = Array(6).fill(0).map((x, i) => { return (i+1) });

  constructor(
    public dialogRef: MatDialogRef<ProbingDepthSegmentsSummaryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.chartTeeth = this.data.chartTeeth;
  }

  ngOnInit() {
    this.generatePerioProbingDepths();
  }

  generatePerioProbingDepths() {
    // sextant 1 = 2-5
    // sextant 2 = 6-11
    // sextant 3 = 12-15
    // sextant 4 = 18-21
    // sextant 5 = 22-27
    // sextant 6 = 28-31

    let probingDepthKeys: string[] = [
      'FacialProbingDepthD',
      'FacialProbingDepthC',
      'FacialProbingDepthM',
      'LingualProbingDepthD',
      'LingualProbingDepthC',
      'LingualProbingDepthM'
    ];

    let sextantObjs: any[] = [
      { sextant: 1, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 2-5
      { sextant: 2, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 6-11
      { sextant: 3, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 12-15
      { sextant: 4, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 18-21
      { sextant: 5, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 22-27
      { sextant: 6, averageProbingDepth: 0, lowestProbingDepth: 0 }, // 28-31
    ];

    this.probingSegmentData = new PerioProbingDepthsBySegment();

    sextantObjs.forEach(sextantObj => {

      let startTooth: number = 0;
      let endTooth: number = 0;

      let averageDepthAccumulator: number = 0;
      let averageDepthCount: number = 0;
      let lowestDepth: number = 100;

      switch (sextantObj.sextant) {
        case 1:
          startTooth = 2;
          endTooth = 5;
          break;
        case 2:
          startTooth = 6;
          endTooth = 11;
          break;
        case 3:
          startTooth = 12;
          endTooth = 15;
          break;
        case 4:
          startTooth = 18;
          endTooth = 21;
          break;
        case 5:
          startTooth = 22;
          endTooth = 27;
          break;
        case 6:
          startTooth = 28;
          endTooth = 31;
          break;
      }

      for (let i = startTooth; i <= endTooth; i++) {
        let index = i - 1;
        let tooth: PerioTooth = this.chartTeeth[index];

        if (!tooth.ToothIsMissing) {
          probingDepthKeys.forEach(key => {

            let toothValue: number = 0;
            let skipFlag: boolean = false;
            if (!isNaN(tooth[key])) {
              toothValue = parseInt(tooth[key]);
            } else {
              skipFlag = true;
            }

            if (!skipFlag) {
              averageDepthAccumulator += toothValue;
              averageDepthCount++;

              if (toothValue < lowestDepth) {
                lowestDepth = toothValue;
              }
            }

          });
        }
      }

      if (averageDepthCount === 0) {
        averageDepthCount = 1;
      }

      var averageDepth: number = averageDepthAccumulator / averageDepthCount;

      this.probingSegmentData[`averageProbingDepthS${sextantObj.sextant}`] = `${(Math.round(averageDepth * 10) / 10)}`;

      if (lowestDepth === 100) {
        lowestDepth = 0;
      }

      this.probingSegmentData[`lowestProbingDepthS${sextantObj.sextant}`] = lowestDepth;

    });

  }

  getSegmentStatKey(segment: number, type: string) {
    if (type === 'average') {
      return `averageProbingDepthS${segment}`;
    } else {
      return `lowestProbingDepthS${segment}`;
    }
  }

  close() {
    this.dialogRef.close();
  }

}
